angular.module('gym.data_series').controller('DataSeriesOptInCtrl', ["$scope", "$rootScope", "$state", "$window", "DataSeries", "FreeTrialRemindMessageText", "GTMService", function($scope, $rootScope, $state, $window, DataSeries, FreeTrialRemindMessageText, GTMService) {
  var billingPageUrl;
  $scope.isFeatureEnabled = !!_.find($rootScope.gym.features_enabled, function(feature) {
    return feature === 'data_series';
  });
  GTMService.trackPage('Access Control Toggle');
  $scope.optIn = function() {
    GTMService.trackPage('Access Control Toggle', 'Let\'s get started');
    return DataSeries.doPOST({}, 'settings/opt_in').then(function() {
      var url;
      url = $state.href('gym.dashboard');
      return $window.open(url, '_self');
    });
  };
  billingPageUrl = $state.href('gym.subscription.tab', {
    tab: 'subscriptions'
  });
  $scope.getRemindMessageText = FreeTrialRemindMessageText.get('Established', billingPageUrl);
  return $scope.isFreeTrialRemindMessageAvailable = $rootScope.gym.on_trial_period && $rootScope.gym.trialling_highest_plan;
}]);
